import styled from 'styled-components';
import { Box } from '@mui/material';

export const ValidationWrapper = styled(Box)`{
    margin-top: 48px;
    margin-bottom: 48px;

    .tabpannel {
        margin-top: 48px;

        button.Mui-selected {
            color: white;
            cursor: pointer;
            border-radius: 5px;
            background-color: #1B4A83;
            text-transform: capitalize;
        }
    }

    .boxWrapper {
        border: 1px solid #1B4A83;
        border-radius: 0px 0px 5px 5px;
        border-top: 5px solid rgb(27, 74, 131);
        padding: 30px;
        background-color:#ffffff;
        .boxContainer {
            display: flex;
            width: 100%;

        }


        .priceCalculation {
            margin-top: 30px;
            

            h3 {
                margin-left: 30px;
                text-align: left;
                color: rgb(27, 74, 131);
            }
                thead {
                    background-color: #bdd0e9;
                    tr {
                      th {
                        font-weight: 600;
                      }
                    }
                }
        }
    }
}
`;


